require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/object/define-property.js
// module id = 945
// module chunks = 48 49 50